
export default {
name: 'BlogCard',
 props: {
    categories: {
      type: Array,
    },
    comments: {
      type: String,
    },
    excerpt: {
      type: String,
    },
    image: {
      type: String,
    },
    title: {
      type: String,
    },
      link: {
      type: String,
    },
  },
}
